import { render, staticRenderFns } from "./SyncSKUDimension.vue?vue&type=template&id=3552e7b6"
import script from "./SyncSKUDimension.vue?vue&type=script&lang=js"
export * from "./SyncSKUDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports